import { render, staticRenderFns } from "./seriesPoster.vue?vue&type=template&id=9c59944c&scoped=true&"
import script from "./seriesPoster.vue?vue&type=script&lang=js&"
export * from "./seriesPoster.vue?vue&type=script&lang=js&"
import style0 from "./seriesPoster.vue?vue&type=style&index=0&id=9c59944c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c59944c",
  null
  
)

component.options.__file = "seriesPoster.vue"
export default component.exports